import s from "./style.module.css";
export interface Input
    extends Marko.HTML.Button, Omit<Marko.HTML.A, "type" | `on${string}`> {
    icon?: Marko.AttrTag<{ content: Marko.Body; position?: "start" | "end" }>;
    size?: "medium" | "large";
    priority?: "primary" | "secondary";
}

<const/{
    icon,
    content,
    size = "large",
    priority = "primary",
    class: className,
    ...rest
}=input>
<const/iconPositon=(icon?.position ?? "end")>
<const/sharedProps={
    "data-evo": "",
    class: [s.button, className],
    "data-size": size,
    "data-priority": priority,
}>

<if=input.href>
    <${"a"} ...rest ...sharedProps>
        <if=icon && iconPositon === "start">
            <${icon.content}/>
        </if>
        <${content}/>
        <if=icon && iconPositon === "end">
            <${icon.content}/>
        </if>
    </>
</if>
<else>
    <${"button"} ...rest ...sharedProps>
        <if=icon && iconPositon === "start">
            <${icon.content}/>
        </if>
        <${content}/>
        <if=icon && iconPositon === "end">
            <${icon.content}/>
        </if>
    </>
    ${" "}
</else>
